import { useLightMode } from '@/hooks/useLightMode'
import { usePermissions } from '@/hooks/usePermissions'
import { useTranslation } from 'react-i18next'

import { Alert, Box, Modal, Text } from '@hivewatch/dark'

interface ArchiveRuleModalIProps {
  isOpen: boolean
  isLoading: boolean
  ruleName: string
  onClose: () => void
  onConfirm: () => void
}

export const ArchiveRuleModal = ({
  isOpen,
  isLoading,
  ruleName,
  onClose,
  onConfirm,
}: ArchiveRuleModalIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const { shouldEnableRemoveModal } = usePermissions()

  return (
    <Modal
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveDestructive
      isSaveDisabled={isLoading || !shouldEnableRemoveModal}
      isSaveLoading={isLoading}
      onClose={onClose}
      onSave={onConfirm}
      saveButtonLabel={t('automations:confirm_archive_button')}
      showCancelButton
      size='compact'
      title={t('automations:confirm_archive_title')}
    >
      <Box data-testid='ArchiveRuleModal:question'>
        {t('automations:confirm_archive_body')}{' '}
        <Text as='span' fontWeight='bold'>
          {ruleName}
        </Text>
        ?
      </Box>
      <Box mt='16px'>
        <Alert
          colorScheme={colorScheme}
          description={t('common:warning_cannot_be_undone')}
          title={t('common:warning_title')}
          variant='warning'
        />
      </Box>
    </Modal>
  )
}
